import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import './main.css'
import { useNavigate } from "react-router-dom";



export default function Hero1({ list }) {


  const isMobile = window.innerWidth <= 768; 
  const banners = isMobile?list.slice(1, 2):list.slice(0, 1); // Adjust the number of banners based on screen size
  console.log(banners)
  
  const navigate = useNavigate()

  const handleNavigate=(id)=>{

  navigate(`/products/${id}`)

  }

  return (
    <div className="hero__cont" style={{maxHeight:'unset',aspectRatio:isMobile?'1':'3.5'}}>
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
      /*   autoplay={{ delay: 2000, disableOnInteraction: false }} */
        modules={[Autoplay]} // You need to register the Autoplay module
        style={{maxWidth:"100vw",aspectRatio:isMobile?'1':'16/9',overflow:'hidden'}}
      >
        {banners.map((item, index) => (
          <SwiperSlide key={index} className="hero__slide" onClick={()=>{handleNavigate(item.id)}}>
            <img src={item.imageUrl} style={{objectFit:'cover'}} alt={`slide-${index}`} className="slide-image" />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="hero__etxts" style={{bottom:'15%'}}>
        <div className="herotexttitle">
          {banners[0].title}
        </div>
        
        <div className="herotextsubtitke">
          {banners[0].subtitle}
        </div>

      {/*   <div className="herotextbutton">
          Order now
        </div> */}
      </div>
    </div>
  );
}